import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ContactDetailPage } from './contact-detail';
import { MomentModule } from 'ngx-moment';

@NgModule({
  declarations: [
    ContactDetailPage,
  ],
  imports: [
    IonicPageModule.forChild(ContactDetailPage),
    MomentModule
  ],
})
export class ContactDetailPageModule {}



// WEBPACK FOOTER //
// ./src/pages/contact-detail/contact-detail.module.ts